import React from 'react';

import { useStore, useMItem } from 'store';
import { POI } from './POI';

export const Billboards = () => {
  const billboards_enabled = useStore((state) => state.scene_controls.billboards_enabled);
  const lattice_graph = useStore((state) => state.billboard_settings.lattice_graph);
  const { billboard_list = [] } = useMItem() || {};

  if (!(billboards_enabled && lattice_graph.length)) {
    return null;
  }

  return (
    <group name="levar_fbx_poi">
      {billboard_list.map((board: any, key: number) => (
        <POI key={key} board={board} point_index={key} />
      ))}
    </group>
  );
};
